(function () {
  function initCases(root) {
    if (!root || root.dataset.mtCasesReady === 'true') return;
    root.dataset.mtCasesReady = 'true';

    var sport = 'all';
    var goals = [];
    var cards = [].slice.call(root.querySelectorAll('[data-mt-case]'));
    var count = root.querySelector('[data-mt-cases-count]');
    var empty = root.querySelector('[data-mt-cases-empty]');
    var list = root.querySelector('[data-mt-cases-list]');
    var more = root.querySelector('[data-mt-cases-more]');
    var sportButtons = root.querySelectorAll('[data-mt-sport]');
    var goalTrigger = root.querySelector('[data-mt-goal-trigger]');
    var goalMenu = root.querySelector('[data-mt-goal-menu]');
    var maxVisible = parseInt(root.dataset.maxVisible || '4', 10);

    function filter() {
      var matched = [];
      cards.forEach(function (card) {
        var sportOk = sport === 'all' || card.dataset.sport === sport;
        var goalValues = (card.dataset.goals || '').split(/\s+/).filter(Boolean);
        var goalsOk =
          !goals.length ||
          goals.some(function (goal) {
            return goalValues.indexOf(goal) > -1;
          });
        if (sportOk && goalsOk) matched.push(card);
        card.classList.add('is-hidden');
      });

      var allMode = sport === 'all' && !goals.length;
      var overflow = !allMode && more && matched.length > maxVisible;
      var visibleCount = overflow ? maxVisible - 1 : Math.min(maxVisible, matched.length);

      matched.slice(0, visibleCount).forEach(function (card) {
        card.classList.remove('is-hidden');
      });

      if (list) {
        list.classList.toggle('is-all-mode', allMode);
        list.classList.toggle('is-filtered-mode', !allMode);
        list.style.setProperty('--visible-count', String(Math.max(1, overflow ? maxVisible : visibleCount)));
      }
      if (more) more.classList.toggle('is-hidden', !(allMode || overflow));
      if (count) {
        count.textContent =
          'Showing ' +
          visibleCount +
          ' of ' +
          matched.length +
          (matched.length === 1 ? ' case' : ' cases');
      }
      if (empty) empty.classList.toggle('is-visible', matched.length === 0);
    }

    sportButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        sport = button.getAttribute('data-mt-sport') || 'all';
        sportButtons.forEach(function (item) {
          item.classList.toggle('is-active', item === button);
        });
        filter();
      });
    });

    if (goalTrigger && goalMenu) {
      goalTrigger.addEventListener('click', function () {
        var open = goalMenu.classList.toggle('is-open');
        goalTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      goalMenu.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
        input.addEventListener('change', function () {
          goals = [].slice
            .call(goalMenu.querySelectorAll('input:checked'))
            .map(function (item) {
              return item.value;
            });
          goalTrigger.textContent =
            'Training Goal · ' + (goals.length ? goals.length + ' selected' : 'All');
          filter();
        });
      });

      document.addEventListener('click', function (event) {
        if (!event.target.closest('[data-mt-goal-wrap]')) {
          goalMenu.classList.remove('is-open');
          goalTrigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    var active = root.querySelector('.mt-cases__sport.is-active');
    if (active) active.click();
    else filter();
  }

  function boot() {
    document.querySelectorAll('[data-mt-cases]').forEach(initCases);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-mt-cases]');
    if (root) {
      root.dataset.mtCasesReady = 'false';
      initCases(root);
    }
  });
})();
